import React from 'react'
import {observer} from "mobx-react";
import {mouseState} from "./state/mouseState";
import themeState from "./state/themeState";
import $ from "jquery"
import experimentState from "./state/experimentState";
import mouse from "./images/mouse.png"

const MouseJQuery = observer(
    class extends React.Component {
        constructor(props) {
            super(props)
            this.state = {manual: props.manual === "true"}
        }

        updateMouse() {
            // console.log("updating mouse to",mouseState.mouse_x,mouseState.mouse_y,mouseState.mouse_visible,document.querySelector('.pointed.manual').getBoundingClientRect())
            let ele = document.querySelector('.pointed.manual')
            let transform = mouseState.mouse_transforms[mouseState.mouse_transforms.length - 1]
            ele.style.left = `${mouseState.mouse_x}px`
            ele.style.top = `${mouseState.mouse_y}px`
            // console.log("updating mouse to",transform.mouse_enter_x,transform.mouse_enter_y,experimentState.fake_mouse_visible,ele.getBoundingClientRect())
            // $('.pointed.manual').offset({left: mouseState.mouse_enter_x, top: mouseState.mouse_enter_y})
        }

        render() {
            return <div
                style={{display: (experimentState.fake_mouse_visible || experimentState.experimentParams.admin) ? "block" : "none"}}>
                <img className="pointed manual" src={mouse} style={{
                    position: "absolute",
                    // width: "8px",
                    // height: "8px",

                    // backgroundColor: "black",
                    // transform: "rotate(45deg)",
                    // borderRadius: "0 50% 50% 50%",
                    width: "16x",
                    height: "16px",
                    // backgroundColor: "white",
                    // backgroundImage: mouse,
                    // backgroundColor:themeState.colour_quartiary
                    // backgroundColor: "red"


                    // zIndex: 9999,
                    // transform: "rotate(0deg)",
                    // borderRadius: "0 50% 50% 50%",
                    pointerEvents: "none",
                }}></img>
            </div>
        }
    }
)

export default MouseJQuery;